import { createFileRoute } from '@tanstack/react-router'
import { Agenda } from '@/features/agenda/Agenda'

export const Route = createFileRoute('/_app/app/agenda/')({
  // A grade cuida da própria margem e da própria rolagem.
  staticData: { moldura: 'tela' },
  component: Agenda,
})
